
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.756 10.244a.833.833 0 00-1.178 0l-1.328 1.329c-.616-.184-1.765-.6-2.494-1.329-.728-.728-1.145-1.877-1.328-2.493l1.328-1.329a.832.832 0 000-1.178L6.423 1.911a.832.832 0 00-1.178 0l-2.26 2.26a1.665 1.665 0 00-.489 1.196c.02 1.186.334 5.308 3.582 8.556 3.248 3.249 7.37 3.562 8.557 3.582h.024c.44 0 .856-.173 1.17-.488l2.26-2.26a.832.832 0 000-1.179l-3.333-3.334zm-.106 5.594c-1.04-.018-4.598-.297-7.394-3.094C4.451 9.94 4.18 6.368 4.163 5.35l1.67-1.67L7.99 5.832 6.91 6.911a.834.834 0 00-.226.76c.02.096.509 2.368 1.892 3.751 1.383 1.384 3.656 1.873 3.752 1.893a.827.827 0 00.76-.226l1.078-1.077 2.155 2.155-1.672 1.67z"}})])
          )
        }
      }
    